import { Toast } from 'vant';

/**
 * 验证手机号
 * @param phone(String) 手机号
 * @returns {*}
 */
export const verifyPhoneNumber = function (phone: string) {
  if (!phone) {
    Toast('手机号不能为空');
    return false;
  }
  const reg = /^1\d{10}$/;
  return reg.test(phone);
};

/**
 * 验证手机验证码
 * @param code(String) 验证码
 * @returns {*}
 */
export const verifySmsCode = function (code: string) {
  const reg = /^[0-9]\d*|0$/;
  return reg.test(code);
};

/**
 * 验证姓名
 * @param code(String) 姓名
 * @returns {*}
 */
export const nameValidate = function (name: string) {
  const reg = /^[a-zA-Z\u4e00-\u9fa5]+$/;
  return reg.test(name);
};

// 名字校验，支持中文名字2-20位
export const validateName = function (name: string) {
  return /^[\u4E00-\u9FA5\uf900-\ufa2d]{2,20}$/.test(name);
};

/**
 * 验证身份证号
 * @param code(String) 身份证
 * @returns {*}
 */
export const cardValidate = function (card: string) {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  return reg.test(card);
};

/*身份证号码验证
    身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
   */
export const verifyCardNo = (card: string) => {
  const reg =
    /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/;
  return reg.test(card);
};
